export const ANIMAL_ACTION = "Animal";
export const ACTION_ROLE = "Role";
export const RESET_ACTION = "Reset";
export const ETAT_ACTION = "Etat";
export const ACTION_ADD = "Add";
